module.exports = __webpack_public_path__ + "img/img_quanbao@2x.96e46bee.png";